import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[10px] text-[13px] font-semibold transition-all duration-[160ms] [transition-timing-function:cubic-bezier(0.16,1,0.3,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-[14px] [&_svg]:shrink-0 select-none",
  {
    variants: {
      variant: {
        default:
          "bg-gold-gradient text-[hsl(var(--primary-foreground))] font-bold shadow-[0_2px_12px_rgba(212,168,67,0.30),inset_0_1px_0_rgba(255,255,255,0.20)] hover:shadow-[0_4px_20px_rgba(212,168,67,0.45),inset_0_1px_0_rgba(255,255,255,0.25)] hover:-translate-y-px active:translate-y-0",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-[rgba(212,168,67,0.30)] bg-transparent text-muted-foreground hover:border-[rgba(212,168,67,0.60)] hover:text-[hsl(var(--gold-400,43_62%_47%))] hover:bg-[rgba(212,168,67,0.06)]",
        secondary:
          "border border-border bg-card text-foreground/85 hover:bg-muted hover:border-strong",
        ghost: "text-foreground/70 hover:bg-foreground/[0.05] hover:text-foreground",
        link: "text-[hsl(var(--primary))] underline-offset-4 hover:underline hover:brightness-110",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-11 rounded-[10px] px-6 text-sm",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
